import { useEffect, useState } from 'react';
import { getKeyPickupSummaries } from 'src/services/client';
import {
  ICalcomApiResult,
  IKeyPickupSummary,
} from 'src/pages/Calendar/CalcomIntegration/types';

export interface IUseKeyPickupSummaries {
  summaryFor: (propertyId: string) => IKeyPickupSummary | null;
  isLoading: boolean;
  error: string | null;
}

export const useKeyPickupSummaries = (): IUseKeyPickupSummaries => {
  const [summariesByProperty, setSummariesByProperty] = useState<
    Record<string, IKeyPickupSummary>
  >({});
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSummaries = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    const result: ICalcomApiResult<IKeyPickupSummary[]> =
      await getKeyPickupSummaries();

    if (!result.ok) {
      setError(result.error ?? 'Failed to fetch key-pickup summaries');
      setIsLoading(false);
      return;
    }

    const byProperty: Record<string, IKeyPickupSummary> = {};

    (result.data ?? []).forEach((summary: IKeyPickupSummary) => {
      byProperty[summary.propertyId] = summary;
    });

    setSummariesByProperty(byProperty);
    setIsLoading(false);
  };

  const summaryFor = (propertyId: string): IKeyPickupSummary | null => {
    return summariesByProperty[propertyId] ?? null;
  };

  useEffect(() => {
    void fetchSummaries();
  }, []);

  return {
    summaryFor,
    isLoading,
    error,
  };
};